import ga from '../utils/ga'

export const reportOpenSearchFilterPanel = (panelName: number) => {
  ga('send', 'event', 'Search', 'click', `open panel ${panelName}`)
}

export const reportToggleFiltersPanel = (expanded: boolean) => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'FilterUsage',
    eventAction: 'click',
    eventLabel: expanded ? 'Close' : 'Open'
  })
}
